import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom';
import ExpandedCard from './modals/ExpandedCard';
import { debouncedGetChooseJob, resetOpenJob, setIsNewJob } from '../store/job/actions';
import { initializePusher, unbindPusher } from '../pusherManager';
import { getCookie } from '../helpers/globals';


export const JobModal = (props) => {
    const modalRef = React.useRef(null);
    const [selectedJob, setSelectedJob] = useState(props.newJob.data);
    const [archivedJob, setArchivedJob] = useState(false);
    const [pulseAnimation, setPulseAnimation] = useState(false)

    const history = useHistory();
    const { isNewJob, setIsNewJob } = props
    const orgId = getCookie('active_organization_id')

    useEffect(() => {
        setSelectedJob(props.newJob.data)
    }, [props.newJob.data])

    
    const changeBackground = (color) => {
        setSelectedJob({ ...selectedJob, color_id: color?.id, job_color: color })
    }

    const onArchiveJob = (status) => {
        // status - 0: archive, 1: unarchive
        if (status === 0) {
            setArchivedJob(true)
        } else if (status === 1) {
            setPulseAnimation(false)
            setArchivedJob(false)
            setTimeout(() => {
                setPulseAnimation(false)
            }, 5000)
        }
    }

    return (
        <>
            <div className="expandedcard_section">
                <div
                    id="expandCard"
                    className={`${pulseAnimation ? `pulseAni` : ''}`}
                >
                    {!props.newJob.loading &&
                        <div className='card-color-line' style={{
                            background:
                                (props?.colorList?.data?.length > 0 && selectedJob?.color_id) ?
                                    `linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.25) 100%), ${props?.colorList?.data.find(data => { return data?.id === selectedJob?.color_id })?.['color']}`
                                    : ''
                        }} />
                    }
                    <div
                        className="expandedcard_modal"
                        style={{ backgroundColor: 'white' }}
                    >
                        <ExpandedCard
                            isCardChanged={false}
                            item={props.newJob.data}
                            changeBackground={(color) => changeBackground(color)}
                            currentUser={props.user}
                            loading={props.newJob.loading}
                            onArchiveJob={() => onArchiveJob()}
                            isNewJob={isNewJob} />
                    </div>
                    <img ref={modalRef}
                        className="extend-modal-close modal-close"
                        alt=""
                        src={require(
                            '../assets/images/production_board/modal-close.svg').default}
                        onClick={(e) => {
                            e.preventDefault()
                            window.history.pushState({}, '', `#${history.location.pathname}`)
                            setSelectedJob({})
                            setIsNewJob(false)
                            if (props.newJob?.isFirstJob)
                                history.push("/planning")
                        }}
                    />
                </div>
            </div>
            <div className="expandCardBack"
                onClick={(e) => {
                    e.preventDefault()
                    window.history.pushState({}, '', `#${history.location.pathname}`)
                    setSelectedJob({})
                    props.resetOpenJob()
                    setIsNewJob(false)
                    if (props.newJob?.isFirstJob)
                        history.push("/planning")
                }}
            ></div>
        </>
    )
}

const mapStateToProps = (state) => ({
    jobStatuses: state.JobReducer.jobStatuses,
    colorList: state.JobReducer.colorList,
    assignedUsers: state.JobReducer.assignedUsers,
    filterOptions: state.JobReducer.filterOptions,
    user: state.UserReducer.user,
    newJob: state.JobReducer.newJob,
    isNewJob: state.JobReducer.isNewJob
})

const mapDispatchToProps = (dispatch) => {
    return {
        debouncedGetChooseJob: (id, loading) => debouncedGetChooseJob(dispatch, id, loading),
        resetOpenJob: () => dispatch(resetOpenJob()),
        setIsNewJob: (isNew) => dispatch(setIsNewJob(isNew))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobModal)